import styled from 'styled-components';
import { Headline3 } from './../../app/common/typography';

export const ModalContainer = styled.div`
  text-align: center;
`;

export const IconContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const OfflineTitle = styled(Headline3)`
  margin-bottom: ${({ theme }) => theme.spacing.m};
  color: ${({ theme }) => theme.colors.eerieBlack};
`;

export const ButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xm};
  display: flex;
  justify-content: center;
`;
